import { Component, OnInit, Input } from '@angular/core';
import { config as conf } from 'src/app/config';

@Component({
    selector: 'app-subject-header',
    templateUrl: './subject-header.component.html',
    styleUrls: ['./subject-header.component.scss']
})
export class SubjectHeaderComponent {
    public pageIconPath = `${conf.PAGE_ICON_PATH}`;

    @Input() steps = false; // Show steps if true

    @Input() public stepsCount = 4; // Total steps count; default = 4 based on regsiter steps

    @Input() public stepsActive = 0; // The number of steps that are active

    @Input() public title = ''; // page title

    @Input() public icon = '';
}
